"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var syncValidate = function syncValidate(component, valueToValidate, fieldValues) {
  var _component$props = component.props,
    required = _component$props.required,
    _component$props$labe = _component$props.label,
    label = _component$props$labe === void 0 ? 'Field' : _component$props$labe,
    _component$props$vali = _component$props.validate,
    validate = _component$props$vali === void 0 ? {} : _component$props$vali;
  var validationsResult = {
    isValid: true,
    errors: {},
    pendingValidations: {},
    timestamp: new Date()
  };
  if (required) {
    validationsResult.isValid = valueToValidate !== undefined && valueToValidate !== null && valueToValidate !== '';
    if (!validationsResult.isValid) {
      validationsResult.errors.required = "".concat(label, " is required.");
    }
  }
  Object.keys(validate).forEach(function (validationKey) {
    var validator = validate[validationKey];
    var result = validator.validate({
      value: valueToValidate,
      fieldValues: fieldValues
    });
    if (typeof result === 'function') {
      validationsResult.pendingValidations[validationKey] = {
        validate: result,
        message: validator.message
      };
      return;
    }
    if (result === false) {
      validationsResult.isValid = false;
      validationsResult.errors[validationKey] = validator.message || "Error in ".concat(validationKey, " validation");
    }
  });
  return validationsResult;
};
var asyncValidate = function asyncValidate(component, valueToValidate, fieldValues, validationsResult) {
  if (!validationsResult.isValid || !Object.keys(validationsResult.pendingValidations).length) {
    return validationsResult;
  }
  var asyncValidationsResult = {
    isValid: validationsResult.isValid,
    errors: validationsResult.errors || {},
    timestamp: new Date()
  };
  var promises = [];
  Object.keys(validationsResult.pendingValidations).forEach(function (validationKey) {
    var validator = validationsResult.pendingValidations[validationKey];
    var promise = validator.validate({
      value: valueToValidate,
      fieldValues: fieldValues
    })["catch"](function () {
      return false;
    }).then(function (result) {
      if (result === false) {
        asyncValidationsResult.isValid = false;
        asyncValidationsResult.errors[validationKey] = validator.message || "Error in ".concat(validationKey, " validation");
      }
    });
    promises.push(promise);
  });
  return Promise.all(promises).then(function () {
    return asyncValidationsResult;
  });
};
var _default = exports["default"] = {
  syncValidate: syncValidate,
  asyncValidate: asyncValidate
};
//# sourceMappingURL=FormValidator.js.map